var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCircleX24Px(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/Filled/circle-x_24px") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ideation",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "In-Treatment-2-Copy",
    transform: "translate(-1592.000000, -294.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/Filled/circle-x_24px",
    transform: "translate(1588.000000, 290.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "circle-x",
    transform: "translate(4.000000, 4.000000)",
    fill: "#8A9092"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,0 C3.58125,0 0,3.58125 0,8 C0,12.41875 3.58125,16 8,16 C12.41875,16 16,12.41875 16,8 C16,3.58125 12.41875,0 8,0 Z M11.321875,10.765625 C11.5894375,11.0815625 11.5499063,11.5553125 11.2335,11.8228125 C11.09375,11.940625 10.921875,12 10.75,12 C10.537125,12 10.3253125,11.9096562 10.176875,11.734375 L8,9.1625 L5.821875,11.734375 C5.675,11.909375 5.4625,12 5.221875,12 C5.078125,12 4.90625,11.940625 4.765625,11.821875 C4.449375,11.5543125 4.4096875,11.080625 4.67725,10.7646875 L7.01875,8 L4.678125,5.234375 C4.409375,4.91875 4.45,4.44375 4.765625,4.178125 C5.08125,3.909375 5.55625,3.95 5.821875,4.265625 L8,6.8375 L10.1771875,4.264375 C10.4442813,3.948125 10.9184375,3.9078125 11.234375,4.176 C11.550625,4.4435625 11.5903125,4.91725 11.32275,5.2331875 L8.98125,8 L11.321875,10.765625 Z",
    id: "Shape"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleX24Px);
export default __webpack_public_path__ + "static/media/circle-x_24px.7589285d.svg";
export { ForwardRef as ReactComponent };